import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ExpandMore } from "@mui/icons-material";
import { Rank } from "@/modules/user/types/index.v2";
import TargetInputs from "@/modules/targets/components/target-configurations/targets-template/target-inputs";
import { TargetTemplateType } from "@/modules/targets/types";
import {
  EnvironmentVariables,
  OrganizationTierTypes,
} from "@/modules/common/types";
import { useTargetsTemplateContext } from "@/modules/targets/context/targets-template.context";

interface RankTargetProps {
  rank: Rank;
}

const RankTarget = ({ rank }: RankTargetProps) => {
  const theme = useTheme();

  const { subDepartment } = useTargetsTemplateContext();

  const showMinimumTarget =
    (rank.hasMinimumTarget &&
      subDepartment?.hasTarget &&
      subDepartment?.name.toLowerCase().includes("primary") &&
      EnvironmentVariables.COMPANY_NAME.toString() ===
        OrganizationTierTypes.NAWY) ||
    EnvironmentVariables.COMPANY_NAME.toString() ===
      OrganizationTierTypes.TASKEEN;
  return (
    <Accordion
      disableGutters
      sx={{
        display: "flex",
        flexDirection: "column",
        alignSelf: "stretch",
        borderRadius: theme.nawy.radius.xl,
        background: theme.nawy.colors.semantic.layer.secondary,
        boxShadow: "none",
        "&:before": {
          display: "none",
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="panel2-content"
        id="panel2-header"
      >
        <Typography
          sx={{
            ...theme.nawy.typography.english.variants.body.md.semibold,
          }}
          textTransform="capitalize"
        >
          {rank.title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: theme.nawy.spacing.md,
        }}
      >
        {rank.hasTarget && (
          <TargetInputs targetType={TargetTemplateType.PERSONAL} rank={rank} />
        )}
        {showMinimumTarget && (
          <TargetInputs targetType={TargetTemplateType.MINIMUM} rank={rank} />
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default RankTarget;
